import { render } from "./ReleaseNotes.vue?vue&type=template&id=c58b9756"
import script from "./ReleaseNotes.vue?vue&type=script&lang=js"
export * from "./ReleaseNotes.vue?vue&type=script&lang=js"
script.render = render

export default script